"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logExposure = exports.getLaunchDarklyUserId = void 0;
const constants_1 = require("./constants");
const snowplow_1 = require("../snowplow");
function getLaunchDarklyUserId(cookie) {
    if (!cookie) {
        return null;
    }
    const matcher = new RegExp(`${constants_1.LAUNCHDARKLY_USERID.cookieName}=([^;]+);?`);
    const match = cookie.match(matcher);
    return match?.[1] || null;
}
exports.getLaunchDarklyUserId = getLaunchDarklyUserId;
function logExposure(options) {
    if (typeof window !== "undefined") {
        const { testName, testVariant } = options;
        const userId = getLaunchDarklyUserId(document.cookie);
        (0, snowplow_1.trackCustomEvent)(snowplow_1.EventSchema.ExperimentationExposure, {
            segmentationAttr: userId,
            segmentationAttrName: constants_1.LAUNCHDARKLY_USERID.cookieName,
            testName,
            variant: testVariant,
        });
    }
}
exports.logExposure = logExposure;
//# sourceMappingURL=utils.js.map